import debug from 'debug';

debug.log = console.log.bind(console);

/**
 * Factory for creating namespaced debug loggers using the `debug` npm package.
 *
 * Usage:
 *   import makeDebug from '../../../../makeDebug';
 *   const debug = makeDebug('sync:my-component');
 *   debug('my message', someData);
 *
 * Output is DISABLED by default. To enable, set in browser console:
 *   localStorage.debug = 'sync:*';       // enable all sync namespaces
 *   localStorage.debug = '*';            // enable everything
 *   localStorage.debug = 'sync:authenticator'; // enable specific namespace
 *
 * Then reload the app. Logs appear via console.log (overridden above).
 */
export default debug;
